import React from "react";
import {TableLink} from "peggirkit";
import {FormattedMessage} from "react-intl";

type Props = {
    to: string,
    disabled?: boolean,
};

const ViewFormatter = ({to, disabled = false}: Props) => {
    return (
        <TableLink
            buttonAction={{
                as: "reactRouterLink",
                actionProps: {to},
            }}
            disabled={disabled}
        >
            <FormattedMessage id={"view"}/>
        </TableLink>
    );
};

export default ViewFormatter;